import { Position, Toaster, Classes } from "@blueprintjs/core";

/** Singleton toaster instance. Create separate instances for different options. */
export var AppToaster = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP
});

export var ToastSuccess = function ToastSuccess(msg) {
  AppToaster.show({ className: Classes.INTENT_SUCCESS, message: msg });
};

export var ToastError = function ToastError(msg) {
  AppToaster.show({ className: Classes.INTENT_DANGER, message: msg });
};

export var ToastWarning = function ToastWarning(msg) {
  AppToaster.show({ className: Classes.INTENT_WARNING, message: msg });
};